module.exports = __webpack_public_path__ + "img/girl-violin.7a6badcd.png";